// extracted by mini-css-extract-plugin
export default {"privacyPolicyPage":"PrivacyPolicy_privacyPolicyPage__9Ck83","content":"PrivacyPolicy_content__o9SFJ"};